import { render, staticRenderFns } from "./ScheduledServiceOptimizer.vue?vue&type=template&id=378dd2a5&scoped=true"
import script from "./ScheduledServiceOptimizer.vue?vue&type=script&lang=js"
export * from "./ScheduledServiceOptimizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378dd2a5",
  null
  
)

export default component.exports